export default __webpack_public_path__ + "static/media/position_block.2f427592.svg";